import { CREATE_REQUEST_STATUS, REQUEST_TYPES } from "@demandproai/shared";

const NON_TERMINAL_RECORD_STATUSES = [
    CREATE_REQUEST_STATUS.PENDING,
    CREATE_REQUEST_STATUS.DEFERRED,
    CREATE_REQUEST_STATUS.IN_PROGRESS
];

/**
 * Terminal means the record is done being worked on, whether it succeeded, failed, or came back bad.
 * @param {string} status - a CREATE_REQUEST_STATUS value
 * @returns {boolean}
 */
export function isTerminalRecordStatus(status) {
    return !NON_TERMINAL_RECORD_STATUSES.includes(status);
}

export function getHasCompletedMedicalOrDemandRequest(createRequests) {
    try {
        for (const [key, request] of Object.entries(createRequests)) {
            if (request.status === CREATE_REQUEST_STATUS.COMPLETED && (key === REQUEST_TYPES.DEMAND || key === REQUEST_TYPES.MEDICAL_SUMMARY)) {
                return true;
            }
        }
        return false;
    } catch{
        return false;
    }
}